module.exports = __webpack_public_path__ + "static/img/t13-logo.e6430ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/t13-logo.png
// module id = +dAr
// module chunks = 1